{
  "version": 1,
  "asset_id": "d8314ecb-9a6f-4b1d-bf74-fd5be91077e6",
  "project_id": "e1a64cc6-0fc8-4a5b-9036-8fa01cc3f811",
  "url": "/__l5e/assets-v1/d8314ecb-9a6f-4b1d-bf74-fd5be91077e6/clip-img_0226.mp4",
  "r2_key": "a/v1/e1a64cc6-0fc8-4a5b-9036-8fa01cc3f811/d8314ecb-9a6f-4b1d-bf74-fd5be91077e6/clip-img_0226.mp4",
  "original_filename": "clip-img_0226.mp4",
  "size": 664635,
  "content_type": "video/mp4",
  "created_at": "2026-08-15T18:34:12Z"
}
